import { render, staticRenderFns } from "./package-summary.vue?vue&type=template&id=074cf373&scoped=true"
import script from "./package-summary.vue?vue&type=script&lang=js"
export * from "./package-summary.vue?vue&type=script&lang=js"
import style0 from "./package-summary.vue?vue&type=style&index=0&id=074cf373&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074cf373",
  null
  
)

export default component.exports